import { useEffect, useState } from 'react'
import { supabase } from './supabase'

// Funzioni accese per una lega (badge, sfide): si leggono una volta per lega e si ricordano per la sessione
const cache = new Map()

export function useLeagueFeatures(leagueId) {
  const [features, setFeatures] = useState(() => cache.get(leagueId) ?? { badges: false, rivalry: false, ready: false })
  useEffect(() => {
    if (!leagueId) return
    const hit = cache.get(leagueId)
    if (hit) { setFeatures(hit); return }
    let cancelled = false
    supabase.from('dim_league').select('badges_enabled, rivalry_enabled').eq('id_league', leagueId).maybeSingle()
      .then(({ data }) => {
        const f = { badges: !!data?.badges_enabled, rivalry: !!data?.rivalry_enabled, ready: true }
        if (data) cache.set(leagueId, f)
        if (!cancelled) setFeatures(f)
      })
    return () => { cancelled = true }
  }, [leagueId])
  return features
}
